// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"d9075d78","1808":"6c7d28be","2446":"049c45e2"}[chunkId] + ".chunk.css";
};